// Import all images
const images = {
    stackguard: process.env.PUBLIC_URL + '/stackguard.png',
    dashboard: process.env.PUBLIC_URL + '/dashboard.svg',
    dashboard2: process.env.PUBLIC_URL + '/dashboard2.svg',
    repo: process.env.PUBLIC_URL + '/repo.svg',
    repo2: process.env.PUBLIC_URL + '/repo2.svg',
    integration: process.env.PUBLIC_URL + '/integration.svg',
    integration2: process.env.PUBLIC_URL + '/integraion2.svg',
    settings: process.env.PUBLIC_URL + '/settings.svg',
    search: process.env.PUBLIC_URL + '/search.svg',
    bellcon: process.env.PUBLIC_URL + '/bellcon.svg',
    github: process.env.PUBLIC_URL + '/login/github.svg',
  };
  
  export default images; 